import Cookies from "universal-cookie";
import { CookieConcentInformation } from "../Types/CookieConcentInformation";
import { useState } from "react";

export const useCookieConcent = () => {
  const cookieName = 'OneFrontCookieConcent';

  const GetCookieConcent = () => {
    return new Cookies().get(cookieName) as CookieConcentInformation | null;
  };

  const ActivateGoogleAnalytics = () => {
    window.gtag('config', 'G-BWZH8XKY95');
  }

  const SaveCookieConcent = (cookieConcent: CookieConcentInformation) => {
    const cookies = new Cookies();

    if (cookieConcent.analytics) {
      ActivateGoogleAnalytics();
    }
    cookies.set(cookieName, JSON.stringify(cookieConcent), { maxAge: 31536000 });
  };
  return {
    SaveCookieConcent,
    GetCookieConcent,
    ActivateGoogleAnalytics
  };
};

